"use strict";

exports.__esModule = true;
exports.SessionSeekable = void 0;
var _ReportsManager = require("../Core/ReportsManager");
var _Session2 = require("../Public/Session");
var _Constant = require("../Utils/Constant");
var _YoLog = require("../Utils/YoLog");
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
// In order to handle jitter in a player while seeking, e.g. the user may seek forward,
// change their mind, attempt to seek back to the same location, and then play; the resulting seek
// will not be exactly zero, and this would mark any playing advert inactive.
// This value determines the value under which the playhead is deemed NOT to have seeked.
// It is set at 2x the Yospace recommended minimum cadence of 250ms.
var ADVERT_START_THRESHOLD = 2 * _Constant.Constant.MAX_CADENCE;

/**
  *  Abstract Session implementation representing any seekable stream
  * @hideconstructor
  */
var SessionSeekable = /*#__PURE__*/function (_Session) {
  _inheritsLoose(SessionSeekable, _Session);
  function SessionSeekable(properties) {
    var _this;
    _this = _Session.call(this, properties) || this;
    _this.didSeek = false;
    _this.duration = 0;
    return _this;
  }

  /**
   * @returns {number} the duration of the stream
   */
  var _proto = SessionSeekable.prototype;
  _proto.getDuration = function getDuration() {
    // Default implementation.  Can be overridden in derived classes.
    return this.duration;
  };
  _proto.initialiseFromAnalyticData = function initialiseFromAnalyticData(payload, scheme) {
    this.setPlaybackUrl(scheme + payload.getHostNode() + payload.getHostSuffix());
    this.setDuration(payload.getStreamDuration());
    this.setIdentifier(payload.getSessionIdentifier());
    Array.prototype.push.apply(this.linearAdBreaks, payload.getLinearAdBreaks());
    Array.prototype.push.apply(this.nonLinearAdBreaks, payload.getNonLinearAdBreaks());
    Array.prototype.push.apply(this.displayAdBreaks, payload.getDisplayAdBreaks());
  };
  _proto.mergePlaceholderBreaks = function mergePlaceholderBreaks(vmapResponse) {
    var success = true;
    for (var i = 0; i < this.linearAdBreaks.length; ++i) {
      var lab = this.linearAdBreaks[i];
      if (lab.isPlaceholder()) {
        for (var _iterator = _createForOfIteratorHelperLoose(vmapResponse.getLinearAdBreaks()), _step; !(_step = _iterator()).done;) {
          var latest = _step.value;
          if (lab.getIdentifier() === latest.getIdentifier() && lab.getStart() === latest.getStart()) {
            latest.postParse(this);
            this.linearAdBreaks[i] = latest;
          }
        }
      }
      if (this.linearAdBreaks[i].isPlaceholder()) {
        _YoLog.YoLog.e("Placeholder AdBreak with id " + lab.getIdentifier() + " not found");
        success = false;
      }
    }
    return success;
  };
  _proto.onAdvertBreakStart = function onAdvertBreakStart(adbreak) {
    if (this.getCurrentAdBreak()) {
      return;
    }
    this.setCurrentAdBreak(adbreak);
    _YoLog.YoLog.trace("adbreakStart");
    this.getReportsManager().raiseAdBreakCallback("start", this.getCurrentAdBreak(), this);
    if (adbreak && !this.reportsManager.shouldSuppress("breakStart")) {
      var report = adbreak.getTrackingReport("breakStart", true);
      this.getReportsManager().fireBeacon(report, new _ReportsManager.ReportingParams(this.getPlayhead()));
    }
  };
  _proto.onAdvertBreakEnd = function onAdvertBreakEnd() {
    var adbreak = this.getCurrentAdBreak();
    if (adbreak && !this.reportsManager.shouldSuppress("breakEnd")) {
      var report = adbreak.getTrackingReport("breakEnd", true);
      this.getReportsManager().fireBeacon(report, new _ReportsManager.ReportingParams(this.getPlayhead()));
    }
    _YoLog.YoLog.trace("adbreakEnd");
    this.getReportsManager().raiseAdBreakCallback("end", null, this);
    this.setCurrentAdBreak(null);
  };
  _proto.onAdvertEnd = function onAdvertEnd() {
    var advert = this.getCurrentAdvert();
    if (advert && advert.isActive()) {
      this.signalTimelineTrackingEvents(advert.getStart() + advert.getDuration());
    }
    if (advert) {
      advert.setInactive();
    }
    _YoLog.YoLog.trace("advertEnd");
    this.getReportsManager().raiseAdvertCallback("end", null, this);
    this.setCurrentAdvert(null);
  };
  _proto.onAdvertStart = function onAdvertStart(advert) {
    if (this.getCurrentAdvert()) {
      return;
    }
    this.setCurrentAdvert(advert);
    _Session.prototype.onAdvertStart.call(this, advert);
    if (this.getReportsManager().reportsSuppressed()) {
      // clear the advert tracking map because beacons are not fired for partial adverts
      advert.removeTrackingSchedule();
    }
    _YoLog.YoLog.trace("advertStart");
    this.getReportsManager().raiseAdvertCallback("start", advert, this);
    if (advert && advert.isActive()) {
      // fire impressions
      this.fireImpressionReport();

      // fire any tracking urls at start
      this.signalTimelineTrackingEvents(_Constant.Constant.ADVERT_START_TIMESLOT);
    }
  };
  _proto.handlePostSeek = function handlePostSeek(playhead) {
    var previousPlayhead = this.getLastPlayed();
    _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "handlePostSeek: " + previousPlayhead + " -> " + playhead);

    // Only if the playhead has sought more than 2 maximum cadences into a new ad, or the playhead sought backwards,
    // then mark the new ad inactive.
    var interval = playhead - previousPlayhead;
    if (interval >= 0 && interval <= ADVERT_START_THRESHOLD) {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "handlePostSeek: ignoring interval " + interval + "ms");
    } else {
      if (!this.getCurrentAdBreak()) {
        this.handlePostSeekForContent(playhead);
      } else {
        // In a break
        this.handlePostSeekForAdBreak(previousPlayhead, playhead);
      }
    }
  };
  _proto.handlePostSeekForContent = function handlePostSeekForContent(playhead) {
    var ab = this.adBreakForPlayhead(playhead);
    if (ab) {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "handlePostSeek: CONTENT -> BREAK");

      // The playhead has sought into the middle of the ad.  Clear the whole map for this ad
      // (Session does not raise any tracking events at all for any ad which hasn't been played from the start)
      var ad = ab.getAdvertFromPlayhead(playhead);
      if (ad && playhead - ad.getStart() > ADVERT_START_THRESHOLD) {
        ad.setInactive();
      }
    } else {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "handlePostSeek: within content");
    }
  };
  _proto.handlePostSeekForAdBreak = function handlePostSeekForAdBreak(previousPlayhead, playhead) {
    var ab = this.adBreakForPlayhead(playhead);
    if (!ab) {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "handlePostSeek: BREAK -> CONTENT");

      // the playhead has sought out of the end of the ad (in either direction).  Mark the ad inactive
      // (an event has either been played already or else never will be).
      var lastAd = this.getCurrentAdBreak().getAdvertFromPlayhead(previousPlayhead);
      if (lastAd) {
        lastAd.setInactive();
      }
    } else {
      if (ab !== this.getCurrentAdBreak()) {
        // The playhead has sought out of one adbreak straight into another, with no intervening content.
        // This is the same as BREAK/CONTENT followed by CONTENT/BREAK.
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "handlePostSeek: BREAK -> BREAK");
        var _lastAd = this.getCurrentAdBreak().getAdvertFromPlayhead(previousPlayhead);
        if (_lastAd) {
          _lastAd.setInactive();
        }
        var ad = ab.getAdvertFromPlayhead(playhead);
        if (ad && playhead - ad.getStart() > ADVERT_START_THRESHOLD) {
          ad.setInactive();
        }
      } else {
        // ad -> ad?
        this.handlePostSeekForAdvertToAdvert(playhead);
      }
    }
  };
  _proto.handlePostSeekForAdvertToAdvert = function handlePostSeekForAdvertToAdvert(playhead) {
    var ad = this.getCurrentAdBreak().getAdvertFromPlayhead(playhead);
    if (ad) {
      // The playhead has either sought out of the current ad, or sought within it, so
      // mark the current ad inactive.
      this.getCurrentAdvert().setInactive();
      if (ad !== this.getCurrentAdvert()) {
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "handlePostSeek: ADVERT -> ADVERT");

        // The playhead has sought out of one ad and into another (in either direction), so
        // mark the new ad inactive
        if (playhead - ad.getStart() > ADVERT_START_THRESHOLD) {
          ad.setInactive();
        }
      } else {
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "handlePostSeek: with advert");
      }
    }
  };
  _proto.handleHeartbeat = function handleHeartbeat(playhead) {
    _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "handleHeartbeat (playhead: " + playhead + ")");
    if (this.didSeek) {
      this.handlePostSeek(playhead);
      this.didSeek = false;
    }
    var previousPlayhead = this.getLastPlayed();
    this.setPlayhead(playhead);
    if (!this.getCurrentAdBreak()) {
      this.handleHeartbeatForContent(previousPlayhead, playhead);
    } else {
      // in a break
      this.handleHeartbeatForAdbreak(playhead);
    }
  };
  _proto.handleHeartbeatForContent = function handleHeartbeatForContent(previousPlayhead, playhead) {
    var missed = this.missedOpportunityBreak(previousPlayhead, playhead);
    if (missed) {
      var params = new _ReportsManager.ReportingParams(this.getPlayhead());
      this.getReportsManager().fireBeacon(missed.getTrackingReport("breakStart", true), params);
      this.getReportsManager().fireBeacon(missed.getTrackingReport("breakEnd", true), params);
      if (this.linearAdBreaks.indexOf(missed) !== -1) {
        this.linearAdBreaks.splice(this.linearAdBreaks.indexOf(missed), 1);
      }
    }
    var ab = this.adBreakForPlayhead(playhead);
    if (ab) {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "CONTENT -> BREAK (playhead: " + playhead + ")");

      // content -> adbreak
      this.onAdvertBreakStart(ab);

      // Start the ad which should be playing according to the playhead
      var ad = ab.getAdvertFromPlayhead(playhead);
      if (ad) {
        this.onAdvertStart(ad);
      }
    }
  };
  _proto.handleHeartbeatForAdbreak = function handleHeartbeatForAdbreak(playhead) {
    var ab = this.adBreakForPlayhead(playhead);
    if (!ab) {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "BREAK -> CONTENT");

      // End the ad that was playing
      this.onAdvertEnd();
      this.onAdvertBreakEnd();
    } else {
      if (ab !== this.getCurrentAdBreak()) {
        // Edge case: the playhead is moving from one adbreak straight into another with no intervening content.
        // This is the same as BREAK -> CONTENT followed by CONTENT -> BREAK
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "BREAK -> BREAK");
        this.onAdvertEnd();
        this.onAdvertBreakEnd();
        this.onAdvertBreakStart(ab);
        var ad = ab.getAdvertFromPlayhead(playhead);
        if (ad) {
          this.onAdvertStart(ad);
        }
      } else {
        // Otherwise ad -> ad?
        this.handleHeartbeatForAdvertToAdvert(playhead);
      }
    }
  };
  _proto.handleHeartbeatForAdvertToAdvert = function handleHeartbeatForAdvertToAdvert(playhead) {
    var ad = this.getCurrentAdBreak().getAdvertFromPlayhead(playhead);
    if (ad) {
      if (ad !== this.getCurrentAdvert()) {
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_STATE_MACHINE, "ADVERT -> ADVERT");
        this.onAdvertEnd();
        this.onAdvertStart(ad);
      } else {
        // Fire any quartiles
        var delta = Math.max(playhead - this.getCurrentAdvert().getStart(), 0);
        this.signalTimelineTrackingEvents(delta);
      }
    }
  };
  _proto.adBreakForPlayhead = function adBreakForPlayhead(playhead) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(this.linearAdBreaks), _step2; !(_step2 = _iterator2()).done;) {
      var ab = _step2.value;
      if (ab.getStart() <= playhead && playhead < ab.getStart() + ab.getDuration()) {
        return ab;
      }
    }
    return null;
  };
  _proto.missedOpportunityBreak = function missedOpportunityBreak(previousPlayhead, playhead) {
    for (var _iterator3 = _createForOfIteratorHelperLoose(this.linearAdBreaks), _step3; !(_step3 = _iterator3()).done;) {
      var ab = _step3.value;
      // playhead at zero, at location or just passed?
      if (ab.getDuration() === 0) {
        var start = ab.getStart();
        if (previousPlayhead <= start && playhead >= start) {
          return ab;
        }
      }
    }
    return null;
  };
  _proto.onPlaybackStart = function onPlaybackStart(playhead) {
    _Session.prototype.onPlaybackStart.call(this, playhead);
    this.handleHeartbeat(playhead);
  };
  _proto.setAdBreaksInactivePriorTo = function setAdBreaksInactivePriorTo(playhead) {
    for (var _iterator4 = _createForOfIteratorHelperLoose(this.linearAdBreaks), _step4; !(_step4 = _iterator4()).done;) {
      var ab = _step4.value;
      if (!ab.setAdvertsInactivePriorTo(playhead)) {
        break;
      }
    }
  };
  return SessionSeekable;
}(_Session2.Session);
exports.SessionSeekable = SessionSeekable;